import React from 'react';
import check from '../../../../assets/images/purple-check.svg';
import InfoIcon from './InfoIcon';

const InfoRow = ({ feature, bold, partial, index }) => {
	if (partial != null) {
		var text = '';
		var highlighted = false;
		if (index == 0) {
			text = 'Manage ' + feature[partial];
		} else if (feature[partial] === '*') {
			text = feature[0];
		} else if (feature[partial]) {
			text = feature[partial];
		} else {
			return null;
		}

		if (partial > 2 && feature[partial - 1] != feature[partial]) {
			highlighted = true;
		}

		return (
			<div className={'row-container' + (bold ? ' bold-text' : '')}>
				<div className="flex-title">
					<div
						className={
							'left-text' + (highlighted ? ' purple-text' : ' ')
						}
					>
						{text}
					</div>
				</div>
				<div className="flex-1">
					<InfoIcon text={feature[1]} left={true} />
				</div>
			</div>
		);
	}

	return (
		<div className={'row-container' + (bold ? ' bold-text' : '')}>
			<div className="flex-title">
				<div className="left-text">{feature[0]}</div>
			</div>
			<div className="flex-1">
				<InfoIcon text={feature[1]} />
			</div>
			<div className="flex-4">
				{feature[2] == '*' ? <img src={check} alt="i" /> : feature[2]}
			</div>
			<div className="flex-4">
				{feature[3] == '*' ? <img src={check} alt="i" /> : feature[3]}
			</div>
			<div className="flex-4">
				{feature[4] == '*' ? <img src={check} alt="i" /> : feature[4]}
			</div>
		</div>
	);
};

export default InfoRow;
